module.exports = __webpack_public_path__ + "img/Wp_2065.bd9cd099.png";